import { produce } from "immer";
import { ArrowTypes } from "../../../utils/constants";
import { ProcessTypes } from "../../../utils/icons";
import { arrayMoveMutable } from "../../../utils/array";
const utils = (context) => {};

const main = (context) => {
  const { dispatch, current } = context;
  return {
    add: async (rowId, startColumnId, endColumnId, newArrowId) => {
      const minusToPlus = endColumnId?.includes("Plus") && startColumnId?.includes("Minus");
      const arrowType = !minusToPlus && current.type === ProcessTypes.Posting ? ArrowTypes.Parallel : ArrowTypes.Normal;
      let prevRowState = [];
      current.design.arrows = produce(current.design.arrows, (arrows) => {
        if (!arrows[rowId]) {
          arrows[rowId] = [];
        }
        // Do not use immer draft it will give the error
        // Cannot perform 'get' on a proxy that has been revoked
        if (current.design.arrows) prevRowState = [...(current.design.arrows[rowId] ?? [])];

        arrows[rowId].push({
          id: newArrowId,
          startPlayerId: startColumnId,
          endPlayerId: endColumnId,
          type: arrowType,
        });
      });
      dispatch("cells/persistDimensions", "arrows", { root: true });

      return () => {
        current.design.arrows = produce(current.design.arrows, (arrows) => {
          arrows[rowId] = prevRowState;
        });
        dispatch("cells/persistDimensions", "arrows", { root: true });
      };
    },
    update: async (arrow) => {
      const prevRowState = [...(current.design.arrows[arrow.rowId] ?? [])];

      const { startPlayerId, endPlayerId } = arrow;

      const minusToPlus = endPlayerId?.includes("Plus") && startPlayerId?.includes("Minus");
      let arrowType = !minusToPlus && current.type === ProcessTypes.Posting ? ArrowTypes.Parallel : ArrowTypes.Normal;
      arrow = { ...arrow, type: arrowType };

      const rowId = arrow.rowId;
      current.design.arrows = produce(current.design.arrows, (arrows) => {
        if (!arrows[rowId]) {
          arrows[rowId] = []; // Ensure the rowId key exists
        }
        // Update the existing arrow or keep it unchanged
        arrows[rowId] = arrows[rowId].map((existingArrow) => (existingArrow.id === arrow.id ? arrow : existingArrow));
      });
      dispatch("cells/persistDimensions", "arrows", { root: true });
      return () => {
        current.design.arrows = produce(current.design.arrows, (arrows) => {
          arrows[rowId] = prevRowState;
        });
        dispatch("cells/persistDimensions", "arrows", { root: true });
      };
    },
    remove: async (rowId, arrowId) => {
      const prevRowState = [...(current.design.arrows[rowId] ?? [])];
      current.design.arrows = produce(current.design.arrows, (arrows) => {
        arrows[rowId] = current.design.arrows[rowId].filter((arrow) => arrow.id !== arrowId);
      });
      dispatch("cells/resetSelectedArrow", null, { root: true });
      dispatch("cells/persistDimensions", "arrows", { root: true });
      return () => {
        current.design.arrows = produce(current.design.arrows, (arrows) => {
          arrows[rowId] = prevRowState;
        });
        dispatch("cells/persistDimensions", "arrows", { root: true });
      };
    },
    removeByRowIds: async (rowIds) => {
      const prevRowData = {};
      const arrows = { ...current.design.arrows };
      rowIds.forEach((rowId) => {
        if (!arrows[rowId]) return;
        prevRowData[rowId] = arrows[rowId];
        delete arrows[rowId]; // Remove the rowId from the arrows
      });
      current.design.arrows = arrows;
      dispatch("cells/persistDimensions", "arrows", { root: true });
      return () => {
        current.design.arrows = { ...current.design.arrows, ...prevRowData };
        dispatch("cells/persistDimensions", "arrows", { root: true });
      };
    },
    removeByColumnIds: async (columnIds) => {
      const arrows = current.design.arrows;
      const prevArrows = { ...arrows };
      // Filter out arrows whose start or end points are within the columns being removed
      const updatedArrows = Object.fromEntries(
        Object.entries(arrows).filter(([key, arrowList]) =>
          arrowList.every((arrow) => !columnIds.includes(arrow.startPlayerId) && !columnIds.includes(arrow.endPlayerId))
        )
      );
      current.design.arrows = updatedArrows;
      await dispatch("persistDimensions", "arrows");

      return async () => {
        current.design.arrows = prevArrows;
        await dispatch("persistDimensions", "arrows");
      };
    },
    move: (rowId, arrowId, amount) => {
      const prevRowState = [...(current.design.arrows[rowId] ?? [])];

      current.design.arrows = produce(current.design.arrows, (arrows) => {
        const rowArrows = arrows[rowId] || []; // Get the existing row arrows
        const fromIndex = rowArrows.findIndex((x) => x.id === arrowId);
        const toIndex = (fromIndex + amount + rowArrows.length) % rowArrows.length;
        arrayMoveMutable(rowArrows, fromIndex, toIndex);
      });
      dispatch("cells/persistDimensions", "arrows", { root: true });
      return () => {
        current.design.arrows = produce(current.design.arrows, (arrows) => {
          arrows[rowId] = prevRowState;
        });
        dispatch("cells/persistDimensions", "arrows", { root: true });
      };
    },
  };
};

export default (context) => {
  return {
    main: main(context),
    utils: utils(context),
  };
};
